import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header sm:flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-title" }
const _hoisted_4 = { class: "relative sm:w-[265px]" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "trezo-card-subtitle mt-[15px] sm:mt-0 sm:flex items-center gap-[20px]" }
const _hoisted_7 = { class: "trezo-card-dropdown relative mt-[15px] sm:mt-0" }
const _hoisted_8 = { class: "inline-block relative ltr:pr-[17px] ltr:md:pr-[20px] rtl:pl-[17px] rtl:ml:pr-[20px]" }
const _hoisted_9 = { class: "trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[5] dark:bg-dark dark:shadow-none" }
const _hoisted_10 = {
  type: "button",
  class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
}
const _hoisted_11 = {
  type: "button",
  class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
}
const _hoisted_12 = {
  type: "button",
  class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
}
const _hoisted_13 = {
  type: "button",
  class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
}
const _hoisted_14 = {
  type: "button",
  class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
}

import { useClickOutside } from "@/utils/useClickOutside";
import { useI18n } from "vue-i18n";
import enTranslations from "@/i18n/locales/en.json";
import heTranslations from "@/i18n/locales/he.json";
import arTranslations from "@/i18n/locales/ar.json";

// Type definition for translation objects
type TranslationObject = {
  [key: string]: string | TranslationObject;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductsFilter',
  setup(__props) {

const { isActive, toggleActive } = useClickOutside("dropdownToggle");

// i18n setup
const { locale } = useI18n();

// Translation files
const translationFiles = {
  en: enTranslations,
  he: heTranslations,
  ar: arTranslations
};

// Direct translation function that bypasses vue-i18n
const directT = (key: string): string => {
  const parts = key.split('.');
  let result: TranslationObject = translationFiles[locale.value as keyof typeof translationFiles];
  
  for (const part of parts) {
    if (!result || !(part in result)) {
      console.warn(`Missing translation key: ${key} in ${locale.value} locale`);
      // Fallback to English if translation not found
      let enResult: TranslationObject = translationFiles.en;
      for (const fallbackPart of parts) {
        if (!enResult || !(fallbackPart in enResult)) return key;
        enResult = enResult[fallbackPart as keyof typeof enResult] as TranslationObject;
      }
      return typeof enResult === 'string' ? enResult : key;
    }
    result = result[part as keyof typeof result] as TranslationObject;
  }
  return typeof result === 'string' ? result : key;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("label", { class: "leading-none absolute ltr:left-[13px] rtl:right-[13px] text-black dark:text-white mt-px top-1/2 -translate-y-1/2" }, [
            _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, " search ")
          ], -1)),
          _createElementVNode("input", {
            type: "text",
            placeholder: directT('ecommerce.productsGrid.searchHere'),
            class: "bg-gray-50 border border-gray-50 h-[36px] text-xs rounded-md w-full block text-black pt-[11px] pb-[12px] ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[13px] ltr:md:pr-[16px] rtl:pl-[13px] rtl:md:pl-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400"
          }, null, 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass({
              'trezo-card-dropdown-btn inline-block rounded-md border border-gray-100 py-[5px] md:py-[6.5px] px-[12px] md:px-[19px] transition-all hover:bg-gray-50 dark:border-[#172036] dark:hover:bg-[#0a0e19]': true,
              active: _unref(isActive),
            }),
            id: "dropdownToggle",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(toggleActive) && _unref(toggleActive)(...args)), ["stop"]))
          }, [
            _createElementVNode("span", _hoisted_8, [
              _createTextVNode(_toDisplayString(directT('ecommerce.productsGrid.defaultSorting')) + " ", 1),
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "ri-arrow-down-s-line text-lg absolute ltr:-right-[3px] rtl:-left-[3px] top-1/2 -translate-y-1/2" }, null, -1))
            ])
          ], 2),
          _createElementVNode("ul", _hoisted_9, [
            _createElementVNode("li", null, [
              _createElementVNode("button", _hoisted_10, _toDisplayString(directT('ecommerce.productsGrid.defaultSorting')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", _hoisted_11, _toDisplayString(directT('ecommerce.productsGrid.priceLowToHigh')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", _hoisted_12, _toDisplayString(directT('ecommerce.productsGrid.priceHighToLow')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", _hoisted_13, _toDisplayString(directT('ecommerce.productsGrid.topSales')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", _hoisted_14, _toDisplayString(directT('ecommerce.productsGrid.newestArrivals')), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})